var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.user.photoURL === null)?_c('v-avatar',{staticClass:"avatar black--text",style:({backgroundColor: _vm.color}),attrs:{"data-initial":_vm.initials,"size":_vm.avatarSize}},[_vm._v("\n  "+_vm._s(_vm.initials)+"\n  ")]):_c('v-avatar',{staticClass:"avatar",attrs:{"size":_vm.avatarSize}},[_c('img',{attrs:{"src":this.user.photoURL}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24498d02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Avatar.vue
// module id = null
// module chunks = 